export default "__VITE_ASSET__fYV_MtkZ__"